import {Brick, registerBrick} from 'olympe';

export default class MDAPIAddFilterClause extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} column
     * @param {string} operator
     * @param {string} value
     * @param {function(string)} setClause
     */
    update($, [column, operator, value], [setClause]) {
        if (column === '' || operator === '' || value === '') {
            setClause('');
        } else {
            setClause(`and ${column} ${operator} '${value}' `);
        }
    }
}

registerBrick('0188758662693001e24a', MDAPIAddFilterClause);
